import React from 'react';
import { useVideoTransition } from '../hooks/useVideoTransition';
import { useMouseDepthEffect } from '../hooks/useMouseDepthEffect';

const Layout = ({ children, menuOpen, toggleMenu }) => {
    const { contentVisible } = useVideoTransition();
    const { style: depthEffect } = useMouseDepthEffect({
        friction: 1/1000,  // Bigger number is less sensitive
        maxRotate: 0.25    // Limit rotation 
    });

    return (
        <div className="fixed inset-0 overflow-hidden">
            <div 
                className="relative h-full isolation"
                style={{ 
                    opacity: contentVisible ? 1 : 0,
                    transition: 'opacity 200ms ease-out, transform 100ms ease-out',
                    pointerEvents: contentVisible ? 'auto' : 'none',
                    transformOrigin: 'center center',
                    //...depthEffect
                }}
            >
                {children}
            </div>
        </div>
    );
};

export default Layout;